import React from "react"
import { navigate } from "gatsby"

import { AirtableApi } from "../../helpers/AirtableApi"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as registrationFormTM1PyWorkshopStyles from "../../styles/landing_pages/RegistrationFormTM1PyWorkshopStyles.module.css"

export default function RegistrationFormTM1PyWorkshop(props) {
  const { content } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [isSubmitting, setSubmitting] = React.useState(false)
  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const [data, setData] = React.useState({
    email: ``,
    firstName: ``,
    lastName: ``,
    company: ``,
    registrations: [
      {
        name: `novice`,
        checked: false,
      },
      {
        name: `intermediate`,
        checked: false,
      },
      {
        name: `expert`,
        checked: false,
      },
    ],
    dietary: ``,
    questions: ``,
    additionalInfo: ``,
  })

  const handleItemChange = (evt, cat) => {
    let updated = data
    if (Object.keys(evt.target).includes(`checked`)) {
      if (cat) {
        updated[cat].find(({ name }) => name === evt.target.name).checked =
          evt.target.checked
      } else {
        updated[evt.target.name] = evt.target.checked
      }
    } else {
      updated[evt.target.name] = evt.target.value
    }

    setData(updated, forceUpdate())
  }

  const handleSubmit = async evt => {
    evt.preventDefault()

    setHasError(false)
    setSubmitting(true)

    let filteredData = JSON.parse(JSON.stringify(data))
    filteredData[`registrations`] = data[`registrations`]
      .reduce((prev, curr) => {
        if (curr.checked) return [...prev, curr.name]
        return prev
      }, [])
      .toString()

    try {
      const records = await AirtableApi.writeRecord(
        process.env.GATSBY_AIRTABLE_API_TOKEN,
        `appFZf26mEAS4vJ1a`,
        `tm1py-workshop`,
        filteredData,
      )

      const record = records && records.records && records.records[0]
      const submittedPage = record && record.fields[`thankYouPage`]

      setHasError(false)
      setSubmitting(false)
      setSubmitted(true)

      navigate(submittedPage)
    } catch (error) {
      console.error(error)

      setHasError(true)
      setSubmitting(false)
    }
  }

  const header = ChildSelector.select(
    content,
    `header-text`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const experience = ChildSelector.select(
    content,
    `info-text`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return <></>

  return (
    <>
      <div className={`row ${registrationFormTM1PyWorkshopStyles.wrapper}`}>
        <div
          className={`col-xs-12 col-sm-12 col-md-7 col-lg-7 ${registrationFormTM1PyWorkshopStyles.formSubmit}`}
        >
          <h2>{header}</h2>
          <form
            className={`row ${registrationFormTM1PyWorkshopStyles.form}`}
            onSubmit={handleSubmit}
          >
            <div
              className={`col ${registrationFormTM1PyWorkshopStyles.personalInfo}`}
            >
              <label htmlFor="firstName">First Name *</label>
              <input
                id="firstName"
                type="text"
                className="form-control"
                name="firstName"
                value={data.firstName}
                required
                onChange={handleItemChange}
              />
            </div>
            <div
              className={`col ${registrationFormTM1PyWorkshopStyles.personalInfo}`}
            >
              <label htmlFor="lastName">Last Name *</label>
              <input
                id="lastName"
                type="text"
                className="form-control"
                name="lastName"
                value={data.lastName}
                required
                onChange={handleItemChange}
              />
            </div>
            <div
              className={`col ${registrationFormTM1PyWorkshopStyles.personalInfo}`}
            >
              <label htmlFor="email">Email *</label>
              <input
                id="email"
                type="email"
                className="form-control"
                aria-label="Email"
                name="email"
                value={data.email}
                required
                onChange={handleItemChange}
              />
            </div>
            <div
              className={`col ${registrationFormTM1PyWorkshopStyles.personalInfo}`}
            >
              <label htmlFor="company">Company *</label>
              <input
                id="company"
                type="text"
                className="form-control"
                name="company"
                value={data.company}
                required
                onChange={handleItemChange}
              />
            </div>
            <div
              className={`row ${registrationFormTM1PyWorkshopStyles.optionWrapper}`}
            >
              <div
                className={`col ${registrationFormTM1PyWorkshopStyles.option}`}
              >
                <p>{experience}</p>
                {data.registrations.map((it, idx) => (
                  <div
                    key={idx}
                    className={`col ${registrationFormTM1PyWorkshopStyles.option}`}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name={it.name}
                      checked={data.registrations[idx].checked}
                      onChange={evt => handleItemChange(evt, `registrations`)}
                    />
                    <label className="form-check-label">{it.name}</label>
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`row ${registrationFormTM1PyWorkshopStyles.otherInformationWrapper}`}
            >
              <div
                className={`col-12 ${registrationFormTM1PyWorkshopStyles.dietary}`}
              >
                <label htmlFor="dietaryRequirements">
                  Dietary Requirements
                </label>
                <textarea
                  className="form-control"
                  name="questions"
                  rows="2"
                  required
                  values={data.dietary}
                  onChange={handleItemChange}
                ></textarea>
              </div>
              <div
                className={`col-12 ${registrationFormTM1PyWorkshopStyles.questionsTeam}`}
              >
                <label htmlFor="questions">Questions for the team</label>
                <textarea
                  className="form-control"
                  name="questions"
                  rows="2"
                  values={data.questions}
                  onChange={handleItemChange}
                ></textarea>
              </div>
              <div
                className={`col-12 ${registrationFormTM1PyWorkshopStyles.additionalInfo}`}
              >
                <label htmlFor="additionalInfo">Any Other Information</label>
                <textarea
                  className="form-control"
                  name="additionalInfo"
                  rows="2"
                  values={data.additionalInfo}
                  onChange={handleItemChange}
                ></textarea>
              </div>
            </div>

            <div
              className={`col ${registrationFormTM1PyWorkshopStyles.validation}`}
            >
              <input
                id="optin"
                type="checkbox"
                className="form-check-input"
                required
              />
              <label htmlFor="optin">
                We would like your permission to reach out to you with more
                information about our products and services. We will only send
                you marketing information we think will be relevant to you. We
                will always treat your personal details with the utmost care and
                will never sell them to other companies for marketing purposes.
              </label>
            </div>
            <div
              className={`row ${registrationFormTM1PyWorkshopStyles.submitSection}`}
            >
              <div
                className={`col ${registrationFormTM1PyWorkshopStyles.submitBtn}`}
              >
                {!isSubmitting && (
                  <button
                    type="submit"
                    className={`${registrationFormTM1PyWorkshopStyles.btn}`}
                  >
                    Register
                  </button>
                )}
                {hasError && (
                  <p>
                    An unexpected error has occurred. Please confirm all data to
                    be correctly input and try again...
                  </p>
                )}
                {isSubmitted && (
                  <p>
                    Thank you for your interest! You will receive an e-mail
                    shortly with a follow up.
                  </p>
                )}
              </div>
            </div>
          </form>
        </div>
        <div
          className={`col-xs-12 col-sm-12 col-md-5 col-lg-5 ${registrationFormTM1PyWorkshopStyles.media}`}
        >
          <WPImage
            holder={content}
            selector={`media-asset`}
            mode={DISPLAY_MODE.normal}
          />
        </div>
      </div>
    </>
  )
}
